"use strict";

define('uikit/modules/dimmer',['backbone', 'marionette', '../mixins/component.mixin', '../templates', '../channel', 'semantic/modules/dimmer'], function (Backbone, Mn, ComponentMixin, Templates, channel, test) {
  var Dimmer = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui dimmer',
    template: Templates.UIKit['dimmer'],
    options: {
      active: false,
      centered: false,
      page: false,
      disabled: false,
      inverted: false
    },
    update: {
      active: false,
      page: false,
      disabled: false,
      inverted: false
    },
    bindings: {},
    _showDimmer: function _showDimmer() {
      if (!this._isShown) {
        return;
      }
      this.$el.dimmer({
        closable: false
      }).dimmer('show');
    },
    _hideDimmer: function _hideDimmer() {
      if (!this._isShown) {
        return;
      }
      this.$el.dimmer('hide');
    },
    onFirstRender: function onFirstRender() {
      if (this._isShown) {
        this._initialEvents();
      } else {
        this.once('show', function () {
          this._initialEvents();
        }, this);
      }
    },
    _initialEvents: function _initialEvents() {
      this.listenTo(this.vent, "change:active", _.debounce(function () {
        if (this.active) {
          this._showDimmer();
        } else {
          this._hideDimmer();
        }
      }, 1));
      if (this.active) {
        this._showDimmer();
      }
    },
    updateAttributes: function updateAttributes() {
      this.addClass('page', this.getBoolOption('page')).addClass('disabled', this.getBoolOption('disabled')).addClass('inverted', this.getBoolOption('inverted'));
    },
    onBeforeDestroy: function onBeforeDestroy() {
      this.stopListening(this.vent);
    }
  });
  channel.reply('dimmer', function () {
    return Dimmer;
  });
  return Dimmer;
});

